'use client';

import Link from 'next/link';
import { ComponentProps, useState } from 'react';

const HoverPrefetchLink = (props: ComponentProps<typeof Link>) => {
  const { onMouseEnter, onTouchStart } = props;

  const [active, setActive] = useState(false);

  return (
    <Link
      prefetch={props.prefetch || active}
      onMouseEnter={e => {
        onMouseEnter?.(e);
        setActive(true);
      }}
      onTouchStart={e => {
        onTouchStart?.(e);
        setActive(true);
      }}
      {...props}
    />
  );
};

export default HoverPrefetchLink;
